import { CompactNumber } from "@/shared/ui/CompactNumber";
import { Card, CardContent } from "@/components/ui/card";
import {
  BanknoteIcon,
  PauseCircleIcon,
  UserPlusIcon,
  WalletIcon,
} from "lucide-react";

type WalletSummaryCardsProps = {
  totalActiveWallet: number;
  totalBalance: number;
  suspendedCount: number;
  newToday: number;
  isLoading?: boolean;
};

export function WalletSummaryCards({
  totalActiveWallet,
  totalBalance,
  suspendedCount,
  newToday,
  isLoading,
}: WalletSummaryCardsProps) {
  if (isLoading) {
    return (
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <Card key={i} className="rounded-xl border bg-card">
            <CardContent>
              <div className="h-10 animate-pulse rounded bg-muted" />
              <div className="mt-2 h-6 w-16 animate-pulse rounded bg-muted" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <Card className="rounded-xl border border-blue-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-blue-500/10">
            <WalletIcon className="size-5 text-blue-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ບັນຊີໃຊ້ງານທັງໝົດ
            </p>
            <p className="font-semibold text-2xl tabular-nums">
              <CompactNumber value={totalActiveWallet} />
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-emerald-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-emerald-500/10">
            <BanknoteIcon className="size-5 text-emerald-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ຍອດລວມ (LAK)
            </p>
            <p className="font-semibold text-2xl tabular-nums">
              <CompactNumber
                value={totalBalance}
                formatOptions={{
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }}
              />
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-amber-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-amber-500/10">
            <PauseCircleIcon className="size-5 text-amber-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ບັນຊີຕັ້ງລະງັບ
            </p>
            <p className="font-semibold text-2xl tabular-nums">
              <CompactNumber value={suspendedCount} />
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-violet-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-violet-500/10">
            <UserPlusIcon className="size-5 text-violet-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ໃໝ່ມື້ນີ້
            </p>
            <p className="font-semibold text-2xl tabular-nums">
              <CompactNumber value={newToday} />
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
